import { ApplicationProfilesVO } from '../../admin-profile/models/applicationProfile';
import { ResourceVO, RoleVO } from '../../admin-profile/models/resource';
import { ApiResponse } from 'mds-ui/app/shared/model/apiresponse';

export class ApplicationVO {
    applicationId: number;
    name: string;
    displayName: string;
    isActive: string;
    createdBy: string;
    createdTime: Date;
    lastUpdatedBy: string;
    lastUpdatedTime: Date;
    applicationProfiles: ApplicationProfilesVO[];
    resources: ResourceVO[];
    roles: RoleVO[]
}

export class ApplicationResponse {
    apiResponseVO: ApiResponse;
    applicationVOList: ApplicationVO[];
}